import React from 'react'
import { Box, Typography, CssBaseline } from '@mui/material'
import Link from 'next/link'

const UnderConstruction = () => {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f7f7f7',
          textAlign: 'center',
        }}
      >
        <Typography variant="h3" sx={{ mb: 2 }}>
          🚧 Under Construction 🚧
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          This page is currently being built. Please check back later!
        </Typography>
        <Link href="/" passHref>
          <Typography
            variant="button"
            sx={{
              color: '#1976d2',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            Go Back Home
          </Typography>
        </Link>
      </Box>
    </>
  )
}

export default UnderConstruction